import { useEffect as o } from "react";
import { useSetAtom as r } from "jotai/index";
import { setHandleNextStepAtom as m } from "./index25.mjs";
const u = (e = () => !0) => {
  const t = r(m);
  o(() => (t(e), () => {
    t(() => !0);
  }), [e, t]);
};
export {
  u as useHandleNextStep
};
